import styled from 'styled-components'

export const Container = styled.div<{ position: 'bottom' | 'right' }>`
    display: flex;
    flex-direction: ${({ position }) => (position === 'top' || position === 'bottom' ? 'column' : 'flex')};
    gap: ${({ position }) => (position === 'top' || position === 'bottom' ? '12' : '6')}px;

    height: 100%;

    .check-btn,
    .sending-btn {
        width: 128px;
        padding: 4px 16px;
        font-size: 13px;
        font-weight: 500;
        line-height: 15.73px;

        border-radius: 3px;

        &:hover {
            opacity: 0.8;
        }
    }

    .check-btn {
        border: 2px solid var(--gray-400);
        font-weight: 700;

        color: var(--gray-800);
        background-color: transparent;
    }

    .sending-btn {
        border: 2px solid var(--blue-500);
        font-weight: 700;

        color: white;
        background-color: var(--blue-500);
    }
`
